module.exports = __webpack_public_path__ + "static/media/card.244c7c1c.png";